import { render } from "./App.vue?vue&type=template&id=f5ba7d50&scoped=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=f5ba7d50&lang=less&scoped=true"
import "./App.vue?vue&type=style&index=1&id=f5ba7d50&lang=less"
script.render = render
script.__scopeId = "data-v-f5ba7d50"

export default script